import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="bg-foreground/5 py-12">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                    <div>
                        <div className="flex items-center mb-4">
                            <img src="/devotionfund-logo.png" alt="Devotion Fund" className="h-8" />
                        </div>
                        <p className="text-muted-foreground text-sm">
                            {t('footer.blurb')}
                        </p>
                    </div>

                    <div>
                        <h3 className="font-bold text-foreground mb-4">{t('footer.platform')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <Link
                                    to="/how-it-works"
                                    className="text-muted-foreground hover:text-primary transition-colors text-left"
                                >
                                    {t('nav.howItWorks')}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/get-started"
                                    className="text-muted-foreground hover:text-primary transition-colors text-left"
                                >
                                    {t('actions.getStarted')}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/for-churches"
                                    className="text-muted-foreground hover:text-primary transition-colors text-left"
                                >
                                    For churches
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-bold text-foreground mb-4">{t('footer.resources')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <Link
                                    to="/resources"
                                    className="text-muted-foreground hover:text-primary transition-colors text-left"
                                >
                                    {t('nav.resourceArticles')}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/best-practices"
                                    className="text-muted-foreground hover:text-primary transition-colors text-left"
                                >
                                    {t('nav.faqs')}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-bold text-foreground mb-4">{t('footer.company')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <Link
                                    to="/about"
                                    className="text-muted-foreground hover:text-primary transition-colors text-left"
                                >
                                    {t('nav.aboutUs')}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/contact"
                                    className="text-muted-foreground hover:text-primary transition-colors text-left"
                                >
                                    {t('nav.contact')}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/privacy"
                                    className="text-muted-foreground hover:text-primary transition-colors text-left"
                                >
                                    {t('nav.privacy')}
                                </Link>
                                {' | '}
                                <Link
                                    to="/terms"
                                    className="text-muted-foreground hover:text-primary transition-colors text-left"
                                >
                                    {t('nav.terms')}
                                </Link>
                                {' | '}
                                <Link
                                    to="/acceptable-use"
                                    className="text-muted-foreground hover:text-primary transition-colors text-left"
                                >
                                    {t('nav.acceptableUse', 'Acceptable use')}
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-border pt-8 text-center text-sm text-muted-foreground">
                    <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
